// ======== core Vue
import Vue from "vue";

// ======== Main app
import App from "./App.vue";

// ======== Router
import router from "./router";

// ======== Store
import store from "./store";

// ======== language
store.dispatch("lang_module/handleLang"); // ==> Store (Vuex) <==
store.dispatch("theme_module/handleTheme"); // ==> Store (Vuex) <==
import Permission from "@/helpers/permission";
Vue.prototype.$permission = new Permission();

// **** CONSTS
const USER_TOKEN = store.getters["auth_module/currentUser"].token;
const CURRENT_LANG = store.getters["lang_module/lang"];
const COUNTRY = JSON.parse(localStorage.getItem("zoz_dash_country"));

// ========  Start Axios
import axios from "axios";
Vue.prototype.$axios = axios; // Glopal variable
// Vue.prototype.$base_URL = process.meta.env.BASE_URL // Glopal variable

// socket io
import BaseMap1 from "@/components/Maps/BaseMap1.vue";
Vue.component("base-map1", BaseMap1);
// ======== AudioRecorder
import AudioRecorder from "vue-audio-recorder";
Vue.use(AudioRecorder);

// ======== ReadMore
import ReadMore from "vue-read-more";
Vue.use(ReadMore);
// =============> VueChatScroll
import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);

// Global Headers
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL; // baseurl
// axios.defaults.baseURL = "https://newzoz.zoz-app.com/api/admin"; // baseurl
axios.defaults.headers.common["cache-control"] = "no-cache";
axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.common["Accept-language"] = CURRENT_LANG;
axios.defaults.headers.common["lang"] = CURRENT_LANG;
if (COUNTRY) {
  axios.defaults.headers.common["Country-Id"] = COUNTRY.id;
}
axios.defaults.headers.common["Time-Zone-Country-Id"] = COUNTRY
  ? COUNTRY.id
  : "-1 ";
// if (COUNTRY) {
//   axios.defaults.headers.common["time-zone-country-id"] = COUNTRY.id;
// }
import MainFilter from "@/components/Filters/MainFilter.vue";
// Set Token If Exists
if (USER_TOKEN) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + USER_TOKEN;
}

axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    if (error.response?.status == "403") {
      router.push("/permission-required");
    }
    if (error.response?.status == "401") {
      store.dispatch("auth_module/logOut");
    }
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response?.status == "403") {
      router.push("/permission-required");
    }
    if (error.response?.status == "401") {
      store.dispatch("auth_module/logOut");
    }
    return Promise.reject(error);
  }
);
// ======== vue-particles
import VueParticles from "vue-particles";
Vue.use(VueParticles);

// ======== Bootstrap
import "bootstrap/dist/css/bootstrap.css";

// ======== iziToast
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";
Vue.prototype.$iziToast = iziToast; // Glopal variable
Vue.use(iziToast);

// ======== VueLazyload
import VueLazyload from "vue-lazyload";
import loaderGIF from "./assets/images/loader.gif";
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: loaderGIF,
  loading: loaderGIF,
  attempt: 1,
});

// ======== Moment
// const moment = require("moment");
// if (CURRENT_LANG == "ar") {
//   require("moment/locale/ar");
// }
// Vue.use(require("vue-moment"), {
//   moment,
// });

// ======== AOS
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

// ======== i18n
import i18n from "./i18n";

// ======= vuetify
import vuetify from "./plugins/vuetify";
// ======= vuetify

import VueCarousel from "vue-carousel";

Vue.use(VueCarousel);

// =============> Vue Slike Carousal
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
Vue.component("vue-slick", VueSlickCarousel);

// =============> Multiselect
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
Vue.component("multiselect", Multiselect);
// =============> tree
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("treeselect", Treeselect);

// ========  Main Style
import "./assets/scss/main.scss";

// =============> Google Maps
import * as VueGoogleMaps from "vue2-google-maps";
// Vue.use(VueGoogleMaps, {
//   load: {
//     // Add your API key here
//     // key: "AIzaSyDRymdCLWxCwLHFnwv36iieKAMjiwk8sdc",
//     key: "AIzaSyC2MTR_vRbsbQQRPt5f5ZLCvvaKOpzkzlA",
//     libraries: "places", // This is required if you use the Auto complete plug-in
//   },
// });

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    // "geometry" is required to decode the `encoded_polygon` strings returned
    // by GET /api/general/district/{city_id} into drawable polygon paths.
    libraries: "places,geometry",
  },
});
//  =========  vue-excel-export
import excel from "vue-excel-export";
Vue.use(excel);

// ============> Ckeditor
import CKEditor from "ckeditor4-vue";
Vue.use(CKEditor);

// START:: IMPORTING VUE APEX CHARTS
import VueApexCharts from "vue-apexcharts";
Vue.component("apexchart", VueApexCharts);
Vue.use(VueApexCharts);
// END:: IMPORTING VUE APEX CHARTS

// =========== Start Import && Register Global Components ===========
import Breadcrumb from "./components/Global/Breadcrumb.vue";
import ProfileCard from "./components/Global/ProfileCard.vue";
import Statistics from "./components/Global/Statistics.vue";

import BaseModel from "./components/UI/BaseModel.vue";
import BaseMap from "./components/Maps/BaseMap.vue";
import DistrictMapPicker from "./components/Maps/DistrictMapPicker.vue";
import SelectedDistrictsMapPreview from "./components/Maps/SelectedDistrictsMapPreview.vue";
import LocationMap from "./components/Maps/LocationMap.vue";
import BaseCard from "./components/UI/BaseCard.vue";

import UplodeImage from "./components/Uploads/UplodeImage.vue";
import UploadImageDirect from "./components/Uploads/UploadImageDirect.vue";
import UplodeMultiple from "./components/Uploads/UplodeMultiple.vue";
import NotFound from "./components/Global/not-found";

// START:: Main Loader
import MainLoader from "@/components/Loaders/MainLoader.vue";
// END:: Main Loader

Vue.component("MainLoader", MainLoader);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("profile-card", ProfileCard);
Vue.component("base-model", BaseModel);
Vue.component("base-map", BaseMap);
Vue.component("district-map-picker", DistrictMapPicker);
Vue.component("selected-districts-map-preview", SelectedDistrictsMapPreview);
Vue.component("location-map", LocationMap);
Vue.component("base-card", BaseCard);
Vue.component("main-filter", MainFilter);
Vue.component("uplode-image", UplodeImage);
Vue.component("upload-image-direct", UploadImageDirect);
Vue.component("uplode-multiple", UplodeMultiple);
Vue.component("stats-card", Statistics);
Vue.component("NotFound", NotFound);
// =========== End Import && Register Global Components ===========

//  VueSweetalert2
import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

// =========== Table Scroll Navigator Plugin
import TableScrollPlugin from "./plugins/tableScroll";
Vue.use(TableScrollPlugin);

// =========== Mixins
import helpers from "./Mixins/helpers";
Vue.mixin(helpers);

// ======== Attatch and Mount
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
